/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Premium_VoicesInputs */

const en_mobile_premium_voices = /** @type {(inputs: Mobile_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium voices`)
};

const es_mobile_premium_voices = /** @type {(inputs: Mobile_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces premium`)
};

/**
* | output |
* | --- |
* | "Premium voices" |
*
* @param {Mobile_Premium_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_premium_voices = /** @type {((inputs?: Mobile_Premium_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Premium_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_premium_voices(inputs)
	return en_mobile_premium_voices(inputs)
});